import React from 'react';
import { Rate, Tag, Typography } from 'antd';

const { Text, Paragraph } = Typography;

/** Read-only display of the scraped retail data (price, rating, reviews, description). */
export const ExternalDataView = ({ data }) => {
    if (!data || Object.keys(data).filter((k) => k !== 'images').length === 0) {
        return <Text type="secondary">No scraped product data.</Text>;
    }
    const { currentPrice, originalPrice, rating, maxRating, numberOfVoters, description, userReviews } = data;
    const discounted = originalPrice != null && currentPrice != null && originalPrice > currentPrice;
    // Stars are always a 5-point scale; rescale ratings on other scales (e.g. /10).
    const max = maxRating || 5;
    const stars = rating != null ? Math.round(((rating / max) * 5) * 2) / 2 : null;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {(currentPrice != null || originalPrice != null) && (
                <div>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        Price
                    </Text>
                    <div>
                        {currentPrice != null && <Text strong>${currentPrice}</Text>}
                        {discounted && (
                            <Text delete type="secondary" style={{ marginLeft: 8 }}>
                                ${originalPrice}
                            </Text>
                        )}
                    </div>
                </div>
            )}

            {rating != null && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Rate disabled allowHalf value={stars} count={5} style={{ fontSize: 14 }} />
                    <Text>
                        {rating}
                        {max !== 5 ? ` / ${max}` : ''}
                    </Text>
                    {numberOfVoters != null && (
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            ({numberOfVoters} {numberOfVoters === 1 ? 'review' : 'reviews'})
                        </Text>
                    )}
                </div>
            )}

            {description && (
                <div>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        Description
                    </Text>
                    <Paragraph ellipsis={{ rows: 4, expandable: true, symbol: 'more' }} style={{ marginBottom: 0 }}>
                        {description}
                    </Paragraph>
                </div>
            )}

            {Array.isArray(userReviews) && userReviews.length > 0 && (
                <div>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        Reviews
                    </Text>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 4 }}>
                        {userReviews.map((r, i) => (
                            <div
                                key={i}
                                style={{
                                    border: '1px solid #f0f0f0',
                                    borderRadius: 6,
                                    padding: '6px 8px',
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    {r.author && <Text strong style={{ fontSize: 13 }}>{r.author}</Text>}
                                    {r.rating != null && (
                                        <Rate disabled value={r.rating} style={{ fontSize: 11 }} />
                                    )}
                                </div>
                                {r.title && <Text style={{ fontSize: 13 }}>{r.title}</Text>}
                                {r.content && (
                                    <Paragraph
                                        type="secondary"
                                        ellipsis={{ rows: 2, expandable: true, symbol: 'more' }}
                                        style={{ fontSize: 13, marginBottom: 0 }}
                                    >
                                        {r.content}
                                    </Paragraph>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {numberOfVoters != null && rating == null && (
                <Tag>{numberOfVoters} reviews</Tag>
            )}
        </div>
    );
};
